import { render, staticRenderFns } from "./ConsentLetterDataTable.vue?vue&type=template&id=36647727&scoped=true"
import script from "./ConsentLetterDataTable.vue?vue&type=script&lang=js"
export * from "./ConsentLetterDataTable.vue?vue&type=script&lang=js"
import style0 from "./ConsentLetterDataTable.vue?vue&type=style&index=0&id=36647727&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36647727",
  null
  
)

export default component.exports